import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import {
  Container,
  DropdownButton,
  DropdownContainer,
  Label,
  MenuItem,
  Menu,
  Selected,
  Optional,
  MenuItemText,
  Submenu,
  SubmenuContainer,
  SearchContainer,
  SearchBar,
  SearchIcon,
  CloseIcon,
  Overlay,
  Panel,
  Header,
  CloseButtonContainer,
} from './css';
import XIcon from '../../../../assets/icons/x_icon.svg';
import ExpandMenuItem from './ExpandMenuItem';

const NestedDropdown = ({
  input,
  placeholder,
  options,
  optional,
  label,
  disabled,
  search,
  resolution,
}) => {
  const [isOptionsContainerOpen, setIsOptionsContainerOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [searchArray, setSearchArray] = useState([]);
  const [panelOpen, setPanelOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const tempArray = [];
    if (search) {
      options.map((e) => {
        e.children.map((f) => {
          tempArray.push({ value: f.value, code: f.code });
          return undefined;
        });
        return undefined;
      });
    }

    setSearchArray(tempArray);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOptionsContainerOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [setIsOptionsContainerOpen]);

  const handleSelection = (value) => {
    input.onChange(value);

    if (resolution === 'mobile') {
      setPanelOpen(false);
    } else {
      setIsOptionsContainerOpen(false);
    }
  };

  const clearSearchValue = () => {
    setSearchValue('');
  };

  const togglePanel = () => {
    setPanelOpen((prevState) => (!prevState));
  };

  if (resolution === 'mobile') {
    return (
      <>
        <Container>
          <Label>
            {label}
            {' '}
            {optional && (
            <Optional>
              (
              {t('Optional')}
              )
            </Optional>
            )}
          </Label>
          <DropdownContainer ref={containerRef}>
            <DropdownButton
              disabled={disabled}
              onClick={(e) => {
                e.preventDefault();
                togglePanel();
                clearSearchValue();
              }}
            >
              <Selected hasPlaceholder={!input.value}>
                {input.value.name || placeholder}
              </Selected>
            </DropdownButton>
          </DropdownContainer>
        </Container>

        <Overlay isPanelOpen={panelOpen} onClick={togglePanel} />
        <Panel isOpen={panelOpen}>
          <Header>
            <Label className="panel-label">
              {label}
              {' '}
              {optional && (
              <Optional>
                (
                {t('Optional')}
                )
              </Optional>
              )}
            </Label>
            <CloseButtonContainer onClick={togglePanel}>
              <object type="image/svg+xml" data={XIcon} aria-label={t('Close')} />
            </CloseButtonContainer>
          </Header>
          <Menu isOpen={togglePanel} className="panel-menu">
            {search
                    && (
                    <SearchContainer className="search-menu">
                      <SearchBar placeholder="Search" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
                      {searchValue !== '' ? <CloseIcon onClick={clearSearchValue} /> : <SearchIcon />}
                    </SearchContainer>
                    )}
            {options.filter((obj) => obj.value.includes(searchValue.toLowerCase())).map((menuItem) => (
              menuItem.children ? (
                <React.Fragment key={`menu-${menuItem.value}`}>
                  <ExpandMenuItem menuItem={menuItem} handleSelection={handleSelection} />
                </React.Fragment>
              ) : (
                <MenuItemText
                  key={`menuItem-${menuItem.value}`}
                  onClick={() => handleSelection({ name: menuItem.value, code: menuItem.code })}
                >
                  {menuItem.value}
                </MenuItemText>
              )
            ))}
            {searchValue !== '' && searchArray.filter((e) => e.value.includes(searchValue.toLowerCase())).map((subMenuItem) => (
              <MenuItem key={`searchItem-${subMenuItem.value}`}>
                <MenuItemText onClick={() => handleSelection({ code: subMenuItem.code, name: subMenuItem.value })}>
                  {subMenuItem.value}
                </MenuItemText>
              </MenuItem>
            ),
            )}
          </Menu>
        </Panel>
      </>
    );
  }

  return (
    <Container>
      <Label>
        {label}
        {' '}
        {optional && (
        <Optional>
          (
          {t('Optional')}
          )
        </Optional>
        )}
      </Label>
      <DropdownContainer ref={containerRef}>
        <DropdownButton
          disabled={disabled}
          onClick={(e) => {
            e.preventDefault();
            setIsOptionsContainerOpen(!isOptionsContainerOpen);
            clearSearchValue();
          }}
        >
          <Selected hasPlaceholder={!input.value}>
            {input.value.name || placeholder}
          </Selected>
        </DropdownButton>
        <Menu isOpen={isOptionsContainerOpen}>
          {search
                        && (
                        <SearchContainer>
                          <SearchBar placeholder="Search" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
                          {searchValue !== '' ? <CloseIcon onClick={clearSearchValue} /> : <SearchIcon />}
                        </SearchContainer>
                        )}
          {options.filter((obj) => obj.value.includes(searchValue.toLowerCase())).map((menuItem) => (
            menuItem.children ? (
              <React.Fragment key={`menu-${menuItem.value}`}>
                <MenuItem hasChildren={!!menuItem.children} key={menuItem.value}>
                  <MenuItemText>{menuItem.value}</MenuItemText>
                  <SubmenuContainer>
                    <Submenu>
                      {menuItem.children.map((subMenuItem) => (
                        <MenuItem key={`subMenu-${subMenuItem.value}`}>
                          <MenuItemText onClick={() => handleSelection({ code: subMenuItem.code, name: subMenuItem.value })}>
                            {subMenuItem.value}
                          </MenuItemText>
                        </MenuItem>
                      ))}
                    </Submenu>
                  </SubmenuContainer>
                </MenuItem>
              </React.Fragment>
            ) : (
              <MenuItemText
                key={`menuItem-${menuItem.value}`}
                onClick={() => handleSelection({ name: menuItem.value, code: menuItem.code })}
              >
                {menuItem.value}
              </MenuItemText>
            )
          ))}
          {searchValue !== '' && searchArray.filter((e) => e.value.includes(searchValue.toLowerCase())).map((subMenuItem) => (
            <MenuItem key={`searchItem-${subMenuItem.value}`}>
              <MenuItemText onClick={() => handleSelection({ code: subMenuItem.code, name: subMenuItem.value })}>
                {subMenuItem.value}
              </MenuItemText>
            </MenuItem>
          ),
          )}
        </Menu>
      </DropdownContainer>
    </Container>
  );
};

NestedDropdown.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.shape({
      name: PropTypes.string,
      code: PropTypes.string,
    }),
  }),
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      code: PropTypes.string,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
          code: PropTypes.string,
        }),
      ),
    }),
  ),
  optional: PropTypes.bool,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  search: PropTypes.bool,
  resolution: PropTypes.oneOf(['mobile', 'desktop']),
};

export default NestedDropdown;
